import styled from 'styled-components';
import React from 'react';

const Close = styled.a`
  text-decoration: underline;
  color: deepskyblue!important;
  cursor: pointer;
`;

const Card = styled.div`
  background: white;
  border-radius: 5px;
  padding: 60px 30px;
`;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  background: rgba(0, 0, 0, 0.3);
  
  ${Card} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 600px;
  }
`;


export default class AnnouncementModal extends React.Component {
  state = {
    open: true,
  };

  render() {

    if (!this.state.open) return null;

    return (
        <Container {...this.props}>
          <Card>
            🥳 We have exciting news coming soon but will be pausing service until
            further notice.<br/><br/>
            Thanks for using SingleShift!<br/>
            <Close onClick={() => this.setState({open: false})}>Close</Close>
          </Card>
        </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modals/AnnouncementModal.js